import { lazy } from "react"

/**
 * ContentStack Components
 */

export { AshlarRoller, default as Ashlar } from "components/ashlar-wall/Ashlar"
export { default as AshlarWall } from "components/ashlar-wall/AshlarWall"
export { default as CoverEvent } from "components/cover/CoverEvent"
export { default as CoverFeatures } from "components/cover/CoverFeatures"
export { default as CoverRftc } from "components/cover/CoverRftc"
export { default as CoverVarHeight } from "components/cover/CoverVarHeight"
export { default as CoverIntroFixedVideo } from "components/cover/intro/CoverIntroFixedVideo"
export { default as CoverIntroImage } from "components/cover/intro/CoverIntroImage"
export { default as CoverIntroVideo } from "components/cover/intro/CoverIntroVideo"
export { default as CoverTitleFade } from "components/cover/intro/CoverTitleFade"
export { default as CoverImage } from "components/cover/simple/CoverImage"
export { default as CoverVideo } from "components/cover/simple/CoverVideo"
export { default as CoverLana } from "components/cover-lana/CoverLana"
export { default as Coveroller } from "components/coveroller/Coveroller"
export { default as CoverollerDyna } from "components/coveroller-dyna/CoverollerDyna"
export { default as Footer } from "components/footer/Footer"
export { default as HeroMedia } from "components/hero-media/HeroMedia"
export { default as HeroMediaOverlay } from "components/hero-media-overlay/HeroMediaOverlay"
export { default as LegalButton } from "components/legal-notices/LegalButton"
export { default as LegalDefinitionList } from "components/legal-notices/LegalDefinitionList"
export { default as LegalFooter } from "components/legal-notices/LegalFooter"
export { default as LegalHeading } from "components/legal-notices/LegalHeading"
export { default as LegalList } from "components/legal-notices/LegalList"
export { default as LegalNotices } from "components/legal-notices/LegalNotices"
export { default as LegalParagraph } from "components/legal-notices/LegalParagraph"
export { default as CtaLink, default as Link } from "components/link/CtaLink"
export { default as ImageCld } from "components/media/Figure"
export { default as VideoCld } from "components/media/VideoFigure"
export { default as NavigationMain } from "components/nav-v2/Main"
export { default as NavigationSub } from "components/nav-v2/Sub"
export { default as P13n } from "components/p13n/P13n"
export { default as P13nApp } from "components/p13n/P13nApp"
export { default as PageHeading } from "components/page-heading/PageHeading"
export { default as Perso } from "components/perso/Perso"
export { default as PopinButton } from "components/popin-edito/PopinButton"
export { default as Push } from "components/push/Push"
export { default as Stacker } from "components/stacker/Stacker"
export { default as BigHeading } from "components/text/BigHeading"
export { default as Chapo } from "components/text/Chapo"
export { default as Date } from "components/text/Date"
/* MODULAR BLOCKS */
export { default as Heading } from "components/text/Heading"
export { default as Paragraph } from "components/text/Paragraph"
export { default as QuoteBlock } from "components/text/QuoteBlock"
export { default as Rftc } from "components/text/Rftc"
export { default as MoonCalendar } from "components/moon-calendar/MoonCalendar"
export { default as Title } from "components/text/Title"
/* END OF MODULAR BLOCKS */

export const Accessories = lazy(() => import("components/accessories/accessories"))
export const ArticleImage = lazy(() => import("components/articles/ArticleImage"))
export const ArticleOverlay = lazy(() => import("components/articles/ArticleOverlay"))
export const ArticleOverlayRef = lazy(() => import("components/articles/ArticleOverlayRef"))
export const ArticleSimple = lazy(() => import("components/articles/ArticleSimple"))
export const ArticleVarHeight = lazy(() => import("components/articles/ArticleVarHeight"))
export const ArticleImageScrolling = lazy(() => import("components/articles/ArticleImageScrolling"))
export const ArticleOrgWrapper = lazy(() => import("components/articles-org/ArticleOrgWrapper"))
export const BannerPicture = lazy(() => import("components/banner/BannerPicture"))
export const BehindMask = lazy(() => import("components/behind-mask/BehindMask"))
export const BeautyshotCard = lazy(() => import("components/cards/beautyshot-card/BeautyshotCard"))
export const CardVideoPlayer = lazy(() => import("components/cards/CardVideoPlayer"))
export const CardLinkRftc = lazy(() => import("components/cards/CardLinkRftc"))
export const CardPopinRftc = lazy(() => import("components/cards/CardPopinRftc"))
export const CardLightboxRftc = lazy(() => import("components/cards/CardLightboxRftc"))
export const CardVerticalCarousel = lazy(() => import("components/card-vertical-carousel/CardVerticalCarousel"))
export const ComponentRollerAeki = lazy(() => import("components/yet-another-roller/Standalone"))
export const YetAnotherRoller = lazy(() => import("components/yet-another-roller/Roller"))
export const YetAnotherRollerAsOyster100 = lazy(() => import("components/yet-another-roller/standalones/Oyster100"))
export const YetAnotherRollerAsRollerLoop = lazy(() => import("components/yet-another-roller/standalones/RollerLoop"))
export const ConfigLauncher = lazy(() => import("components/config-launcher/ConfigLauncher"))
export const ContactForm = lazy(() => import("components/contact-form/ContactForm"))
export const Countdown = lazy(() => import("components/countdown/Triage"))
export const CoverRevealVideo = lazy(() => import("components/cover/CoverRevealVideo"))
export const CrisSlides = lazy(() => import("components/cris-slides/CrisSlides"))
export const CsrItTable = lazy(() => import("components/csr/Csr"))
export const CsrItTableDynamic = lazy(() => import("components/csr/CsrDynamic"))
export const DownloadsPage = lazy(() => import("components/downloads/DownloadsPage"))
export const EditoExplore = lazy(() => import("components/edito-explore/EditoExplore"))
export const Event = lazy(() => import("components/event/Event"))
export const FamilyVariations = lazy(() => import("components/family-variations/FamilyVariations"))
export const Faq = lazy(() => import("components/faq/Faq"))
export const FindARetailer = lazy(() => import("components/find-a-retailer/FindARetailer"))
export const FocusFeatures = lazy(() => import("components/focus-features/FocusFeatures"))
export const Fragainer = lazy(() => import("components/fragainer/Fragainer"))
export const Gallery = lazy(() => import("components/gallery/Gallery"))
export const HubFilter = lazy(() => import("components/hub-filter/HubFilter"))
export const HubStack = lazy(() => import("components/hub-stack/HubStack"))
export const ImageCard = lazy(() => import("components/roller/cards/ImageCard"))
export const InertCard = lazy(() => import("components/roller-ref/cards/InertCard"))
export const ImageCardLink = lazy(() => import("components/roller/cards/ImageCardLink"))
export const ImageCardPopin = lazy(() => import("components/roller/cards/ImageCardPopin"))
export const ImageSimple = lazy(() => import("components/articles/ImageSimple"))
export const IntroFeaturesBezel = lazy(() => import("components/intro-features-bezel/IntroFeaturesBezel"))
export const Logos = lazy(() => import("components/logos/Logos"))
export const MediaCardLink = lazy(() => import("components/roller/cards/MediaCardLink"))
export const Model = lazy(() => import("components/model/Model"))
export const ModelLauncher = lazy(() => import("components/model/model-box/Launcher")) /** need to be included for preloading purposes */
export const ModelShowVariations = lazy(() => import("components/model/model-variations/Launcher")) /** need to be included for preloading purposes */
export const ModelAccessories = lazy(() => import("components/accessories/model/Model"))
export const NextChapter = lazy(() => import("components/next-chapter/NextChapter"))
export const NextChapterWcard = lazy(() => import("components/next-chapter-wcard/NextChapterWcard"))
// export const P13n = lazy(() => import("components/p13n/P13n"))
export const PopinEdito = lazy(() => import("components/popin-edito/PopinEdito"))
export const PushExtd = lazy(() => import("components/push/PushExtd"))
export const PushCenter = lazy(() => import("components/push/PushCenter"))
export const PushFixed = lazy(() => import("components/push/PushFixed"))
export const PushExtdFixed = lazy(() => import("components/push/PushExtdFixed"))
export const PushReturning = lazy(() => import("components/push-returning/PushReturning"))
export const PushVertical = lazy(() => import("components/push/PushVertical"))
export const Quote = lazy(() => import("components/articles/Quote"))
export const QuickViewEditoCard = lazy(() => import("components/quick-view-cards/QuickViewEditoCard"))
export const QuickViewRollerCard = lazy(() => import("components/quick-view-cards/QuickViewRollerCard"))
export const Retailer = lazy(() => import("components/retailer/Retailer"))
export const Roller = lazy(() => import("components/roller/Roller"))
export const RollerRef = lazy(() => import("components/roller-ref/Roller"))
export const RollerGallery = lazy(() =>
  import("components/yet-another-roller/standalones/RollerLoop").then(module => {
    return { default: module.InterceptRollerLoop }
  })
)
export const RollerLoopDyna = lazy(() => import("components/roller-loop-dyna/RollerLoopDyna"))
// export const RollerGallery = lazy(() => import("components/roller-gallery/RollerGallery"))
export const SavPrice = lazy(() => import("components/servicing-prices/ServicingPrices"))
export const SavCard = lazy(() => import("components/servicing-prices/ServicingCard"))
export const Scrollersive = lazy(() => import("components/scrollersive/Scrollersive"))
export const ScrollersiveWeek = lazy(() => import("components/scrollersive-week/ScrollersiveWeek"))
export const SearchResults = lazy(() => import("components/nav-v2/panes/search/SearchResults"))
export const ScrollingBillboard = lazy(() => import("components/scrolling-billboard/Billboard"))
export const Share = lazy(() => import("components/share/Share"))
export const Skyline = lazy(() => import("components/skyline/Skyline"))
export const SkylineBlock = lazy(() => import("components/skyline/SkylineBlock"))
export const SpecsFeatures = lazy(() => import("components/specs-features/SpecsFeatures"))
export const StoryIntro = lazy(() => import("components/story-intro/StoryIntro"))
export const Test = lazy(() => import("components/test/Test"))
export const Testimonee = lazy(() => import("components/testimonee/Testimonee"))
export const TextImageHorizontal = lazy(() => import("components/articles/TextImageHorizontal"))
export const TextImageVertical = lazy(() => import("components/articles/TextImageVertical"))
export const TextVideoHorizontal = lazy(() => import("components/articles/TextVideoHorizontal"))
export const VideoAutoplay = lazy(() => import("components/video-autoplay/VideoAutoplay"))
export const VideoCard = lazy(() => import("components/roller/cards/VideoCard"))
export const VideoOverlay = lazy(() => import("components/articles/VideoOverlay"))
export const VideoPlayer = lazy(() => import("components/video-player/VideoPlayer"))
export const VideoPlayerTimeline = lazy(() => import("components/video-player-timeline/VideoPlayerTimeline"))
export const VideoPlayerHowTo = lazy(() => import("components/video-player-how-to/VideoPlayerHowTo"))
export const VideoText = lazy(() => import("components/video-text/VideoText"))
export const Herbier = lazy(() => import("components/herbier/Herbier"))
export const Watches = lazy(() => import("components/watches/watches"))
export const WatchSuggestionPush = lazy(() => import("components/push/WatchSuggestionPush"))
export const WatchSuggestions = lazy(() => import("components/watch-suggestions/WatchSuggestions"))
export const Wishlist = lazy(() => import("components/wishlist/Wishlist"))
export const Ymal = lazy(() => import("components/ymal/Ymal"))
export const DiptyqueImage = lazy(() => import("components/diptyque-image/DiptyqueImage"))
export const VideoPlayerExpand = lazy(() => import("components/video-player-expand/VideoPlayerExpand"))
export const WatchOnTime = lazy(() => import("components/watch-on-time/Bootstrap"))
export const WelcomeBack = lazy(() => import("components/welcome-back/WelcomeBack"))
export const EventCard = lazy(() => import("components/event-card/EventCard"))
export const Infografico = lazy(() => import("components/infografico/Infografico"))
export const ArticleCard = lazy(() => import("components/coveroller/Card"))
export const ActionCard = lazy(() => import("components/coveroller/ActionCard"))

/** DEV */
export const DevTransition = lazy(() => import("components/dev/Transition"))
export const Globe = lazy(() => import("components/globe/globe"))
export const GlobeBespoke = lazy(() => import("components/dev/Globe"))
export const StoreLoc = lazy(() => import("components/store-locator/store-locator"))
export const JpegPage = lazy(() => import("components/jpeg-page/JpegPage"))
export const DataHubGrid = lazy(() => import("components/testimonees/HubGrid"))
export const Planet = lazy(() => import("components/planet/Planet"))
export const EoyGrid = lazy(() => import("components/eoy-grid/EoyGrid"))
export const TextFilling = lazy(() => import("components/text-filling/TextFilling"))
export const YetAnotherRollerDemo = lazy(() => import("components/yet-another-roller/demo/Demo"))
export const Aggregator = lazy(() => import("components/aggregator/Aggregator"))

//export const TestImageIm = lazy(() => import("components/test/TestImageIm"))
export const WatchDrag = lazy(() => import("components/watch-drag/WatchDrag"))
export const WatchDragVariations = lazy(() => import("components/watch-drag/WatchDragVariations"))
export const CoverIntroWot = lazy(() => import("components/cover/intro/CoverIntroWot"))
export const DualGrid = lazy(() => import("components/dual-grid/DualGrid"))
export const ScrollingGrid = lazy(() => import("components/scrolling-grid/ScrollingGrid"))
export const CoverSummary = lazy(() => import("components/cover/CoverSummary"))
export const CoverParallaxFullscreen = lazy(() => import("components/cover/CoverParallaxFullscreen"))
export const XplitLauncher = lazy(() => import("components/xplit/launcher/Launcher"))
export const Scrollertease = lazy(() => import("components/scrollertease/Scrollertease"))
export const Scrollercheese = lazy(() => import("components/scrollercheese/Scrollercheese"))

export const PushNotification = lazy(() => import("components/push-notification/PushNotification"))

export const Timeline = lazy(() => import("components/timeline/Timeline"))
export const BeforeAfter = lazy(() => import("components/before-after/BeforeAfter"))

/** retailer component for preloading purpose */
export const Purchasing = lazy(() => import("components/retailer/Purchasing"))
export const Caring = lazy(() => import("components/retailer/Caring"))
export const Establishment = lazy(() => import("components/retailer/Establishment"))
export const Group = lazy(() => import("components/retailer/Group"))
export const Guarantee = lazy(() => import("components/retailer/Guarantee"))
export const Servicing = lazy(() => import("components/retailer/Servicing"))

/** retailer v2 */
export const WrapperRetailer = lazy(() => import("components/retailer/v2/Wrapper"))
export { default as SubNavigationRetailer } from "components/retailer/v2/SubNav"
export const CoverRetailer = lazy(() => import("components/retailer/v2/components/Cover"))
export const testRetailer = lazy(() => import("components/retailer/v2/components/Test"))
export const RetailerClock = lazy(() => import("components/retailer/v2/components/retailer-clock/CoverRetailClock"))
export const StoreText = lazy(() => import("components/retailer/v2/components/RetailerText"))
export const StaticMap = lazy(() => import("components/retailer/v2/components/static-map/StaticMap"))
export const NextChapterRetailer = lazy(() => import("components/retailer/v2/components/NextChapterRetailer"))
export const ServicesPush = lazy(() => import("components/retailer/v2/components/ServicesPush"))
export const CoverRetailerPlaque = lazy(() => import("components/retailer/v2/components/CoverRetailerPlaque"))
export const RetailerImage = lazy(() => import("components/retailer/v2/components/RetailerImage"))
export const SkylineRetailer = lazy(() => import("components/retailer/v2/components/SkylineRetailer"))
export const DynamicMap = lazy(() => import("components/retailer/v2/components/DynamicMap"))
export const RetailerTextImageVertical = lazy(() => import("components/retailer/v2/components/RetailerTextImageVertical"))
